import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { Route, useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import { AppTopbar } from "./AppTopbar";
import { AppFooter } from "./AppFooter";
import { AppMenu } from "./AppMenu";
import { AppConfig } from "./AppConfig";

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";

import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "./assets/demo/flags/flags.css";
import "./assets/demo/Demos.scss";
import "./assets/layout/layout.scss";
import "./App.scss";
import "./app.css";
import { useSelector } from "react-redux";
import LoginScreen from "./app/screens/pages/login_screen";
// import TicketsScreen from './app/screens/pages/dashboard';
// import { useHistory } from 'react-router-dom';
// import TicketChatScreen from './app/screens/pages/ticket_chat_screen';
import Dashboard from "./app/screens/pages/dashboard";
import GenerateTicketsScreen from "./app/screens/pages/generate_tickets_screen";
import UserManagement from "./app/screens/pages/UsersManagement/UserManagement";
import ManageBooth from "./app/screens/pages/BoothManagement/ManageBooth";
import ManageVehicleType from "./app/screens/pages/VehicleType/ManageVehicleType";
import CashSummary from "./app/screens/pages/CashSummary/CashSummary";
import ManageSite from "./app/screens/pages/SiteManagement/ManageSite";
import Revenue_Report from "./app/screens/pages/Revenue_Report/Revenue_Report";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ManageExemptedVehicle from "./app/screens/pages/ExemptedVehicle/ManageExemptedVehicle";
import VehicleReport from "./app/screens/pages/VehicleReport/VehicleReport";
import CollectionReports from "./app/screens/pages/CollectionReports/CollectionReports";
import ActivityReports from "./app/screens/pages/ActivityReports/ActivityReports";
import Dashboardd from "./app/screens/pages/Dashbaord/Dashboard";
import GTagActivityReport from "./app/screens/pages/GTag/GTagActivityReport";
import GTagCollectionReport from "./app/screens/pages/GTag/GTagCollectionReport";
import QRCollectionReport from "./app/screens/pages/QR/QRCollectionReport";
import QRActivityDetail from "./app/screens/pages/QR/QRActivityDetail";
import StateDetails from "./app/screens/pages/StateDetails/state_details";
import PriceConfig from "./app/screens/pages/PriceConfig/PriceConfig";
import DashboardCollectionReport from "./app/screens/pages/Dashbaord/Components/DashboardCollectionReport";
import BarrierLogReport from "./app/screens/pages/BarrierLogReports/BarrierLogReport";

const App = () => {
  const [layoutMode, setLayoutMode] = useState("static");
  const [layoutColorMode, setLayoutColorMode] = useState("light");
  const [inputStyle, setInputStyle] = useState("outlined");
  const [ripple, setRipple] = useState(true);
  const [staticMenuInactive, setStaticMenuInactive] = useState(false);
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
  const copyTooltipRef = useRef();
  const location = useLocation();
  const storedLoginRes = JSON.parse(localStorage.getItem("user"));
  const userTypeIs = storedLoginRes?.role;
  const userSite = storedLoginRes?.site?._id;
  PrimeReact.ripple = true;

  let menuClick = false;
  let mobileTopbarMenuClick = false;

  useEffect(() => {
    if (mobileMenuActive) {
      addClass(document.body, "body-overflow-hidden");
    } else {
      removeClass(document.body, "body-overflow-hidden");
    }
  }, [mobileMenuActive]);

  useEffect(() => {
    copyTooltipRef &&
      copyTooltipRef.current &&
      copyTooltipRef.current.updateTargetEvents();
  }, [location]);

  const onInputStyleChange = (inputStyle) => {
    setInputStyle(inputStyle);
  };

  const onRipple = (e) => {
    PrimeReact.ripple = e.value;
    setRipple(e.value);
  };

  const onLayoutModeChange = (mode) => {
    setLayoutMode(mode);
  };

  const onColorModeChange = (mode) => {
    setLayoutColorMode(mode);
  };

  const onWrapperClick = (event) => {
    if (!menuClick) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }

    if (!mobileTopbarMenuClick) {
      setMobileTopbarMenuActive(false);
    }

    mobileTopbarMenuClick = false;
    menuClick = false;
  };

  const onToggleMenuClick = (event) => {
    menuClick = true;

    if (isDesktop()) {
      if (layoutMode === "overlay") {
        if (mobileMenuActive === true) {
          setOverlayMenuActive(true);
        }

        setOverlayMenuActive((prevState) => !prevState);
        setMobileMenuActive(false);
      } else if (layoutMode === "static") {
        setStaticMenuInactive((prevState) => !prevState);
      }
    } else {
      setMobileMenuActive((prevState) => !prevState);
    }

    event.preventDefault();
  };

  const onSidebarClick = () => {
    menuClick = true;
  };

  const onMobileTopbarMenuClick = (event) => {
    mobileTopbarMenuClick = true;

    setMobileTopbarMenuActive((prevState) => !prevState);
    event.preventDefault();
  };

  const onMobileSubTopbarMenuClick = (event) => {
    mobileTopbarMenuClick = true;

    event.preventDefault();
  };

  const onMenuItemClick = (event) => {
    if (!event.item.items) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }
  };
  const isDesktop = () => {
    return window.innerWidth >= 992;
  };

const menu = [
  {
    items: [
      // {
      //   label: "Dashboard",
      //   icon: "pi pi-fw pi-home",
      //   to: "/",
      // },
      {
        label: "Dashboard",
        icon: "pi pi-fw pi-home",
        to: "/",
      },
      {
        label: "Generate Tickets",
        icon: "pi pi-fw pi-print",
        to: "/new-tickets",
      },
      {
        label: "Users Management",
        icon: "pi pi-fw pi-users",
        to: "/users-management",
      },
      {
        label: "Site Management",
        icon: "pi pi-fw pi-map",
        to: "/site-management",
      },
      ...(!userSite ? [{
        label: "Price Configuration",
        icon: "pi pi-fw pi-map",
        to: "/price-configuration",
      }] : []),
      {
        label: "Booth Management",
        icon: "pi pi-fw pi-building",
        to: "/booth-management",
      },
      {
        label: "Vehicle Type",
        icon: "pi pi-fw pi-car",
        to: "/vehicle-type",
      },
      {
        label: "Exempted Vehicle",
        icon: "pi pi-fw pi-car",
        to: "/exempted-vehicle",
      },
      // ✅ Reports Dropdown
      {
        label: "Reports",
        icon: "pi pi-fw pi-chart-line",
        items: [
          // { label: "Old Reports", icon: "pi pi-fw pi-money-bill", to: "/Reports" },
          { label: "Exempted Vehicle Reports", icon: "pi pi-fw pi-money-bill", to: "/vehicle-Reports" },
          { label: "Collection Report", icon: "pi pi-fw pi-money-bill", to: "/collection-Reports" },
          { label: "Activity Report", icon: "pi pi-sort-amount-up-alt", to: "/activity-report" },
          // { label: "G-Tag Activity Report", icon: "pi pi-sort-amount-up-alt", to: "/g-tag-activity-report" },
          // { label: "G-Tag Collection Report", icon: "pi pi-sort-amount-up-alt", to: "/g-tag-collection-report" },
          { label: "QR Collection Report", icon: "pi pi-sort-amount-up-alt", to: "/qr-collection-report" },
          { label: "QR Activity Detail", icon: "pi pi-sort-amount-up-alt", to: "/qr-activity-detail" },
          { label: "Revenue Report", icon: "pi pi-sort-amount-up-alt", to: "/RevenueReport" },
          { label: "Manual Barrier Log", icon: "pi pi-sort-amount-up-alt", to: "/barrier-log-reports" },
        ],
      },
    ],
  },
];


  const addClass = (element, className) => {
    if (element.classList) element.classList.add(className);
    else element.className += " " + className;
  };

  const removeClass = (element, className) => {
    if (element.classList) element.classList.remove(className);
    else
      element.className = element.className.replace(
        new RegExp(
          "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
          "gi"
        ),
        " "
      );
  };

  const wrapperClass = classNames("layout-wrapper", {
    "layout-overlay": layoutMode === "overlay",
    "layout-static": layoutMode === "static",
    "layout-static-sidebar-inactive":
      staticMenuInactive && layoutMode === "static",
    "layout-overlay-sidebar-active":
      overlayMenuActive && layoutMode === "overlay",
    "layout-mobile-sidebar-active": mobileMenuActive,
    "p-input-filled": inputStyle === "filled",
    "p-ripple-disabled": ripple === false,
    "layout-theme-light": layoutColorMode === "light",
  });

  const loginUser = useSelector((state) => state.loginUser);
  const { error, loading, user } = loginUser;

  return (
    <>
      <ToastContainer />
      {user === undefined ? (
        <Route path="/" component={LoginScreen} />
      ) : (
        <div className={wrapperClass} onClick={onWrapperClick}>
          <Tooltip
            ref={copyTooltipRef}
            target=".block-action-copy"
            position="bottom"
            content="Copied to clipboard"
            event="focus"
          />

          <AppTopbar
            onToggleMenuClick={onToggleMenuClick}
            layoutColorMode={layoutColorMode}
            mobileTopbarMenuActive={mobileTopbarMenuActive}
            onMobileTopbarMenuClick={onMobileTopbarMenuClick}
            onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick}
          />

          <div className="layout-sidebar" onClick={onSidebarClick}>
            <AppMenu
              model={menu}
              onMenuItemClick={onMenuItemClick}
              layoutColorMode={layoutColorMode}
            />
          </div>

          <div className="layout-main-container">
            <div className="layout-main">
              <Route path="/" component={Dashboardd} exact />
            
              <Route
                path="/new-tickets"
                component={GenerateTicketsScreen}
                exact
              />
              <Route
                path="/users-management"
                component={UserManagement}
                exact
              />
              <Route path="/booth-management" component={ManageBooth} exact />
              <Route path="/vehicle-type" component={ManageVehicleType} exact />
              <Route path="/exempted-vehicle" component={ManageExemptedVehicle} exact />
              <Route path="/Reports" component={CashSummary} exact />
              <Route path="/site-management" component={ManageSite} exact />
              <Route path="/price-configuration" component={PriceConfig} exact />
              <Route path="/RevenueReport" component={Revenue_Report} exact />
              <Route path="/collection-Reports" component={CollectionReports} exact />
              <Route path="/barrier-log-reports" component={BarrierLogReport} exact />
              <Route path="/vehicle-Reports" component={VehicleReport} exact />
              <Route path="/qr-collection-report" component={QRCollectionReport} exact />
              <Route path="/qr-activity-detail" component={QRActivityDetail} exact />
              <Route path="/DashboardCollectionReport" component={DashboardCollectionReport} exact />
              <Route path="/activity-report" component={ActivityReports} exact />
              {/* <Route path="/g-tag-activity-report" component={GTagActivityReport} exact />
              <Route path="/g-tag-collection-report" component={GTagCollectionReport} exact /> */}
              <Route path="/state-detail" component={StateDetails} exact />
              {/* <Route path='/api/ticket/:id'  component={TicketChatScreen} exact/> */}
            </div>

            {/* <AppFooter layoutColorMode={layoutColorMode} /> */}
          </div>

          <AppConfig
            rippleEffect={ripple}
            onRippleEffect={onRipple}
            inputStyle={inputStyle}
            onInputStyleChange={onInputStyleChange}
            layoutMode={layoutMode}
            onLayoutModeChange={onLayoutModeChange}
            layoutColorMode={layoutColorMode}
            onColorModeChange={onColorModeChange}
          />

          <CSSTransition
            classNames="layout-mask"
            timeout={{ enter: 200, exit: 200 }}
            in={mobileMenuActive}
            unmountOnExit
          >
            <div className="layout-mask p-component-overlay"></div>
          </CSSTransition>
        </div>
      )}
    </>
  );
};

export default App;
